<template>
  <el-dialog
    title="活动分层修改"
    :visible.sync="dialogVisible"
    width="35%"
    class="activityLevelDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="activityLevelDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动分层" prop="activityLevel">
            <el-select v-model="formData.activityLevel" placeholder="请选择">
              <el-option  v-for="item in activityLevelList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '../../../newApplicationForm/service';

export default {
  data () {
    return {
      rules: {
        activityLevel: [
          { required: true, message: '请选择活动分层', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      activityLevelList: [],
    };
  },
  props: {
    activityCode: {
      type: String,
      default: ''
    },
    activityLevel: {
      type: String,
      default: ''
    },
    activityLevelDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openDailg(val,level){
      this.dialogVisible = val;
       this.$set(this.formData, 'activityLevel', level);

    },
     getActivityLevelList(){
      let params = [
              'activity_level'
            ];
            newApplicationFormApi.getActivityList(params).then(res => {
              if (res.status === '200') {
                this.activityLevelList = res.data.activity_level;
              }
            });
    },
    submit () {
      this.$refs['activityLevelDialogForm'].validate((valid) => {
        if (valid) {
          this.formData.activityCode = this.activityCode; 
           newApplicationFormApi.updateActivity(this.formData).then(res => {
            if (res.status === '200') {
              this.$message.success('修改成功');
              this.$emit('handlerSuccess');
            }
          });
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  },
   mounted() {
    this.getActivityLevelList();
  }
};
</script>

<style scoped>

</style>
